export const stripe = {
    method: 'GET',
    paths: ['/redirect/stripe'],
    fields: {
        code: {
            type: 'keyString',
            required: true,
        },
        state: {
            type: 'keyString',
            required: true,
        },
    },
};
//# sourceMappingURL=oauth_stripe.js.map